import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { WomanGender } from './svg/womanGender';

export const WomanGenderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WomanGender} {...props} />
);
